<template>
  <v-list-item lines="two" link :to="getAccountRouteHandler">
    <div>
      <v-list-item-title>{{ collection.name }}</v-list-item-title>
      <v-list-item-subtitle>{{ typeName }}</v-list-item-subtitle>
    </div>
  </v-list-item>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { AccountLayoutMixin } from '@/bundles/App/mixins/accountMixin';
import { ICollection } from '@/bundles/Tasks/interfaces/ITask';
import { getTaskRelatedRecordRoute, IGetAccountRouteHandler } from '@/bundles/App/helpers';

export default defineComponent({
  name: 'CollectionTile',
  mixins: [AccountLayoutMixin],

  props: {
    collection: {
      type: Object as PropType<ICollection>,
      required: true,
    }
  },

  computed: {
    typeName (): string {
      if (this.collection.type === 'savedset') {
        return 'Saved Set';
      }

      return this.collection.type;
    },
    page: function (): string {
      if (this.collection.address === 'comparable') {
        return 'comparables';
      } else if (this.collection.address === 'request') {
        return 'administration-requests';
      } else if (this.collection.address === 'deal') {
        return 'deals';
      }

      return this.collection.address;
    },
    getAccountRouteHandler (): IGetAccountRouteHandler {
      return this.getAccountRoute(getTaskRelatedRecordRoute(this.collection));
    }
  },
});
</script>
